export const EMAILS = {
  support: 'support@teampaper.me',
};
